import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import foldersReducer from './slices/foldersSlice';
import filterPageReducer from './slices/filterPageSlice';
import filtersReducer from './slices/filtersSlice';
import dashboardReducer from './slices/dashboardSlice';
import modelsReducer from './slices/modelsSlice';
import filesReducer from './slices/filesSlice';
import settingsReducer from './slices/settingsSlice';
import uploadsReducer from './slices/uploadsSlice';
import notificationsReducer from './slices/notificationsSlice';
import { crossTabSyncMiddleware } from './middleware/crossTabSync';

export const store = configureStore({
  reducer: {
    filterPage: filterPageReducer,
    folders: foldersReducer,
    filters: filtersReducer,
    dashboard: dashboardReducer,
    models: modelsReducer,
    files: filesReducer,
    settings: settingsReducer,
    uploads: uploadsReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(crossTabSyncMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
